import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	className: "logo-mark",
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "cds-logo-grad",
			x1: 0,
			y1: 0,
			x2: 1,
			y2: 1,
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: "0%",
				stopColor: "#9900E6"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: "100%",
				stopColor: "#11CAE6"
			})]
		}) }),
		/* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			rx: 8,
			fill: "url(#cds-logo-grad)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22 16c0 3.314-2.686 6-6 6s-6-2.686-6-6 2.686-6 6-6",
			stroke: "white",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 22,
			cy: 10,
			r: 2.5,
			fill: "white"
		})
	]
});
export default SvgLogo;
